const AVATAR_ICON_SIZE_RECORD = {
  xsmall: 14,
  small: 16,
  default: 20,
  large: 24,
  xlarge: 24
};

export { AVATAR_ICON_SIZE_RECORD };
//# sourceMappingURL=icon.mjs.map
